// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TourGuide 组件样式 */

/* 覆盖 Joyride 默认样式 */
.__floater__open {
  filter: none !important;
}

/* 步骤内容样式 */
.react-joyride__tooltip h2,
.react-joyride__tooltip h3 {
  margin-top: 0;
  color: #171a17;
}

.react-joyride__tooltip p {
  margin: 0;
}

.react-joyride__tooltip strong {
  color: #262626;
  font-weight: 600;
}

/* 进度条样式 */
.react-joyride__tooltip__footer {
  margin-top: 20px;
}

/* 按钮样式优化 */
.react-joyride__tooltip button[data-action='primary'] {
  background-color: #171a17;
  transition: all 0.3s;
}

.react-joyride__tooltip button[data-action='primary']:hover {
  color: #171a17;
  background-color: #e3f3cb;
  transform: translateY(-1px);
}

.react-joyride__tooltip button[data-action='back'] {
  color: #666;
  transition: all 0.3s;
}

.react-joyride__tooltip button[data-action='back']:hover {
  color: #333;
}

.react-joyride__tooltip button[data-action='skip'] {
  color: #999;
  transition: all 0.3s;
}

.react-joyride__tooltip button[data-action='skip']:hover {
  color: #666;
}

/* 高亮区域样式 */
.react-joyride__spotlight {
  border-radius: 8px;
}

/* 确保引导层级最高 */
.react-joyride__overlay {
  z-index: 9999 !important;
}

.react-joyride__spotlight {
  z-index: 9999 !important;
}

.__floater {
  z-index: 10000 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/TourGuide/TourGuide.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB,oBAAoB;AACpB;EACE,uBAAuB;AACzB;;AAEA,WAAW;AACX;;EAEE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA,WAAW;AACX;EACE,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* TourGuide 组件样式 */\n\n/* 覆盖 Joyride 默认样式 */\n.__floater__open {\n  filter: none !important;\n}\n\n/* 步骤内容样式 */\n.react-joyride__tooltip h2,\n.react-joyride__tooltip h3 {\n  margin-top: 0;\n  color: #171a17;\n}\n\n.react-joyride__tooltip p {\n  margin: 0;\n}\n\n.react-joyride__tooltip strong {\n  color: #262626;\n  font-weight: 600;\n}\n\n/* 进度条样式 */\n.react-joyride__tooltip__footer {\n  margin-top: 20px;\n}\n\n/* 按钮样式优化 */\n.react-joyride__tooltip button[data-action='primary'] {\n  background-color: #171a17;\n  transition: all 0.3s;\n}\n\n.react-joyride__tooltip button[data-action='primary']:hover {\n  color: #171a17;\n  background-color: #e3f3cb;\n  transform: translateY(-1px);\n}\n\n.react-joyride__tooltip button[data-action='back'] {\n  color: #666;\n  transition: all 0.3s;\n}\n\n.react-joyride__tooltip button[data-action='back']:hover {\n  color: #333;\n}\n\n.react-joyride__tooltip button[data-action='skip'] {\n  color: #999;\n  transition: all 0.3s;\n}\n\n.react-joyride__tooltip button[data-action='skip']:hover {\n  color: #666;\n}\n\n/* 高亮区域样式 */\n.react-joyride__spotlight {\n  border-radius: 8px;\n}\n\n/* 确保引导层级最高 */\n.react-joyride__overlay {\n  z-index: 9999 !important;\n}\n\n.react-joyride__spotlight {\n  z-index: 9999 !important;\n}\n\n.__floater {\n  z-index: 10000 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
